import { render, staticRenderFns } from "./KqReport.vue?vue&type=template&id=015e56da&scoped=true"
import script from "./KqReport.vue?vue&type=script&lang=js"
export * from "./KqReport.vue?vue&type=script&lang=js"
import style0 from "./KqReport.vue?vue&type=style&index=0&id=015e56da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e56da",
  null
  
)

export default component.exports